import { FROM_1_TO_8_REGEX, FROM_0_TO_9999_3_DECIMAL_REGEX } from '#utils/string/regex';
import { getSubStepValues } from '#models/general/steps';
import { getSelectField } from '#utils/select';
import { MEASURE_TYPES } from '#components/general/Input/components/Measure/constants';
import Input from '#components/general/Input';
import AdelphiFieldsRow from '#components/business/AdelphiFieldsRow';

import styles from './styles.module.scss';
import { MASH_DETAILS_FIELDS, MASH_SUBSTEPS_IDS, PEATED_OPTIONS } from './constants';

export const MALT_VARIETY_OPTIONS = {
  LAUREATE: 'laureate',
  CONCERTO: 'concerto',
  GOLDEN_PROMISE: 'goldenPromise',
  SASSY: 'sassy',
  MANUAL: 'manual'
};

const FIELDS_SUM_100_PERCENTAGE = ['firstMaltWeightPercentage', 'secondMaltWeightPercentage'];

const isSum100Percentage = (fields, values) => () => {
  const fieldsSum = fields.reduce((prevValue, actValue) => {
    const currentValue = values[actValue];
    return prevValue + (currentValue ? parseInt(currentValue) : 0);
  }, 0);
  return fieldsSum === 100;
};

export const getMashDetailsFields = ({ values, errors }) => {
  const getMashStrikeValues = getSubStepValues(MASH_SUBSTEPS_IDS.MASH_DETAILS, values, errors);
  return [
    {
      ...getMashStrikeValues(MASH_DETAILS_FIELDS.MASH_ID),
      Component: Input,
      disabled: true,
      noMargin: true,
      className: styles.noMarginRow
    },
    {
      ...getMashStrikeValues(MASH_DETAILS_FIELDS.FILL_ID),
      Component: Input,
      noMargin: true,
      className: styles.noMarginRow
    },
    {
      ...getMashStrikeValues(MASH_DETAILS_FIELDS.MASH_DATE),
      Component: Input,
      type: 'date',
      className: styles.noMarginRow
    },
    {
      ...getMashStrikeValues(MASH_DETAILS_FIELDS.WB_NO),
      Component: Input,
      needsRegex: true,
      customRegex: FROM_1_TO_8_REGEX,
      className: styles.noMarginRow
    },
    {
      ...getMashStrikeValues(MASH_DETAILS_FIELDS.MALT_WEIGHT),
      Component: Input,
      measure: MEASURE_TYPES.KILOGRAMS,
      needsRegex: true,
      customRegex: FROM_0_TO_9999_3_DECIMAL_REGEX,
      className: styles.noMarginRow
    },
    {
      key: 'firstAndSecondMaltWeightPercentage',
      Component: AdelphiFieldsRow,
      className: styles.noMarginRow,
      fields: [
        {
          ...getMashStrikeValues(MASH_DETAILS_FIELDS.FIRST_MALT_WEIGHT_PERCENTAGE),
          Component: Input,
          measure: MEASURE_TYPES.PERCENTAGE,
          registerParams: {
            required: !!values?.[MASH_DETAILS_FIELDS.SECOND_MALT_WEIGHT_PERCENTAGE],
            validate: values?.[MASH_DETAILS_FIELDS.SECOND_MALT_WEIGHT_PERCENTAGE]
              ? isSum100Percentage(FIELDS_SUM_100_PERCENTAGE, values)
              : () => true
          }
        },
        {
          ...getMashStrikeValues(MASH_DETAILS_FIELDS.SECOND_MALT_WEIGHT_PERCENTAGE),
          Component: Input,
          measure: MEASURE_TYPES.PERCENTAGE,
          registerParams: {
            required: !!values?.[MASH_DETAILS_FIELDS.FIRST_MALT_WEIGHT_PERCENTAGE],
            validate: values?.[MASH_DETAILS_FIELDS.FIRST_MALT_WEIGHT_PERCENTAGE]
              ? isSum100Percentage(FIELDS_SUM_100_PERCENTAGE, values)
              : () => true
          }
        }
      ]
    },
    getSelectField({
      field: MASH_DETAILS_FIELDS.MALT_VARIETY,
      substep: MASH_SUBSTEPS_IDS.MASH_DETAILS,
      manualField: MASH_DETAILS_FIELDS.MALT_VARIETY_MANUAL,
      values,
      options: MALT_VARIETY_OPTIONS,
      getValues: getMashStrikeValues
    }),
    getSelectField({
      field: MASH_DETAILS_FIELDS.PEATED,
      substep: MASH_SUBSTEPS_IDS.MASH_DETAILS,
      manualField: MASH_DETAILS_FIELDS.PEATED_MANUAL,
      values,
      options: PEATED_OPTIONS,
      getValues: getMashStrikeValues
    })
  ];
};
